import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { TableKpiProvider } from "./categoryChartData.types";
import { WaterProvider } from "../misc";
import _ from "lodash";
import { Column } from "react-table";
import { TariffStructureToTextValue } from "./fetchFigureTariffStructureProviderChartData";

export const getTariffStructureTableData = (providers: WaterProvider[]) => {
    const data = providers?.map(provider => {
        const tariff = provider?.residentialTariffStruct;
        return {
            name: provider?.name,
            residentialTariffStruct: provider?.residentialTariffStruct,
            residentialTariffStructDisplay: (
                TariffStructureToTextValue?.[tariff ?? "blank"] ?? TariffStructureToTextValue?.blank
            )?.value
        };
    });

    const providerNames = _.join(
        providers.map(d => d.name),
        " - "
    );

    const columns: Column[] = [
        {
            Header: "Organisation",
            accessor: "name" // accessor is the "key" in the data
        },
        {
            Header: "Tariff structure",
            accessor: "residentialTariffStructDisplay"
            // Cell: ({ value }: { value: ResidentialTariffStruct }) => {
            //     return (TariffStructureToTextValue?.[value ?? "blank"] ?? TariffStructureToTextValue?.blank)?.value;
            // }
        }
    ];

    return {
        data: data,
        columns,
        enabledDownload: true,
        isProviderBasedTable: false,
        downloadFileName: `${providerNames} - Tariff structure`,
        className: "tariff-structure-table reporting-table",
        rowClassNames: columns?.map(d => "string-mid")
    };
};

export const fetchTariffStructureTableData: CategoryChartQueryFn = async ({
    categoryChart,
    providers
}: CategoryChartQueryParam): Promise<TableKpiProvider> => {
    if (!providers || providers?.length === 0 || !categoryChart) return null;

    const tableData = getTariffStructureTableData([providers?.[0]].filter(d => d != null));

    return {
        title: null,
        footer: null,
        vis: tableData
            ? [
                  {
                      categoryName: categoryChart?.category?.name,
                      data: tableData,
                      waterProvider: providers?.[0],
                      header: {
                          processed: "Provider wide",
                          value: "Provider wide"
                      },
                      footer: null,
                      type: "tariff-structure"
                  }
              ]
            : []
    };
};
